import styled from 'styled-components';

export const MiniOrbitHeaderDefaultBox = styled.header`
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    min-height: 50px;
    width: 100%;
    background: ${props => props.theme.colors.background};
    z-index: 20;
`;
